/**
 * Establishes an interval-based listener for subtitles associated with an audio player.
 * @param {HTMLAudioElement} audio - HTML5 Audio element.
 * @param {object} group - The subtitle group associated with the audio.
 * @param {function} callback - The callback function to be invoked when a relevant subtitle is found.
 */
export const subtitleIntervalListener = (
  audio: HTMLAudioElement,
  group: any,
  callback: (sub: any) => void,
) => {
  const intervalName = `interval_${audio.id}`;
  let prevSubId: string | undefined;

  // Create an interval that checks the current playback position and matches it with the appropriate subtitle
  (window as any)[intervalName] = setInterval(() => {
    const currentPosition = Math.floor(audio.currentTime * 1000);
    const sub = group.musicSubs.find(
      (musicSub: any) => currentPosition >= musicSub.from && currentPosition <= musicSub.to,
    );

    if (sub && sub.id !== prevSubId) {
      // Invoke the callback function with the matching subtitle
      callback(sub);
      // Update the previous subtitle ID
      prevSubId = sub.id;
    }
  }, 500);

  /**
   * Clears the interval listener and resets the callback.
   */
  const resetInterval = () => {
    clearInterval((window as any)[intervalName]);
    callback(undefined);
  };

  // Event handling for audio player events
  audio.addEventListener('ended', resetInterval);
  audio.addEventListener('pause', resetInterval);
  audio.addEventListener('stop', resetInterval);
};
